export default __webpack_public_path__ + "static/media/teamEffect1.d729f698.png";